/**
 * Prefix marking a photo that is still a local file rather than a saved media
 * record. Review submission uses it to decide what still needs uploading.
 */
export const TEMP_PHOTO_ID_PREFIX = 'temp-';

/**
 * Identity for a staged file, used to reject the same image being added twice.
 *
 * Name alone is not enough — different photos routinely share a name like
 * `IMG_0001.jpg` — so size and last-modified time are folded in as well.
 */
export const getFileKey = (file: File): string =>
  `${file.name}:${file.size}:${file.lastModified}`;

/**
 * Generates the temporary ID for a newly staged photo.
 */
export const createTempPhotoId = (): string =>
  `${TEMP_PHOTO_ID_PREFIX}${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
